<mat-toolbar>Add new work area</mat-toolbar>
<div class="Dialog-body">
  <form>
    
    <mat-form-field style="width: 400px;padding-top: 1.25em;">
      <input type="text" matInput placeholder="Name" [(ngModel)]="selectedName" [ngModelOptions]="{standalone: true}" >
    </mat-form-field>

    <mat-form-field style="width: 400px;padding-top: 1.25em;">
      <input type="text" matInput placeholder="Description"[(ngModel)]="selectedDescription" [ngModelOptions]="{standalone: true}">
    </mat-form-field>

    <mat-form-field style="width: 400px;padding-top: 1.25em;">
      <mat-select placeholder="{{'State'}}"   [(ngModel)]="inputValuestate" name="Site" [formControl]="state" required [disabled]=true>            
        <mat-option *ngFor="let Site of siteCodesList" [value]="Site.Id">
          {{Site.SiteName}} </mat-option>
        </mat-select> 
        <mat-error *ngIf="state.invalid">{{getErrorMessage()}}</mat-error>
    </mat-form-field>

      <div class="buttonbelow">
        <button mat-raised-button (click)="DialogClose()">Cancel</button>   
        <button mat-raised-button (click)="addWorkArea()">Submit</button>
         
      </div>
  </form>

</div>
